import type { ChartConfiguration } from "./chart.js"
import { Chart, registerables } from "./chart.js"

Chart.register(...registerables)

export function initRadarChart() {
  const els = document.querySelectorAll("[data-radar-chart]")

  if (!els.length) return

  for (const el of els) {
    const canvas = el.querySelector(
      "[data-radar-chart-canvas]"
    ) as HTMLCanvasElement
    if (!canvas) continue
    const datasets = el.querySelector(
      "[data-radar-chart-datasets]"
    ) as HTMLScriptElement
    if (!datasets) continue
    const data = JSON.parse(datasets.textContent) as ChartConfiguration["data"]
    if (!data) continue

    const config: ChartConfiguration = {
      type: "radar" as const,
      data: data,
      options: {
        plugins: {
          legend: {
            display: false,
          },
        },
        maintainAspectRatio: false,
        scales: {
          r: {
            angleLines: {
              display: true,
            },
            suggestedMin: 0,
            suggestedMax: 5,
            pointLabels: {
              font: {
                size: 14,
              },
              color: "rgba(0, 0, 0, 0.87)",
              callback: function (label: string, index: number) {
                const value = data.datasets[0].data[index]
                return label.split("\n").concat([`${value}`])
              },
            },
            ticks: {
              display: false,
              stepSize: 1,
            },
          },
        },
      },
    }

    new Chart(canvas, config)
  }
}

initRadarChart()
